import React from 'react';
import ProductInterface from '../ProductInterface';
import ExthrlyOptions from './ExthrlyOptions';
import { processExthrly } from './exthrlyProcess';

export default function Exthrly() {
  return (
      <ProductInterface
          product = "exthrly"
          ProductOptions = {ExthrlyOptions}
          processProduct = {processExthrly}
      />
  )
} 